import {Box, Text} from 'exsportia-components'
import React, {FC} from 'react'

import {inputStyle} from './styles'
import {FieldProps} from './types'

export const ShortTextField: FC<FieldProps> = ({qId, question, value, error, onChange, theme}) => {
  const {config} = question
  return (
    <input
      type='text'
      value={(value as string) || ''}
      placeholder={config?.placeholder || ''}
      onChange={(e) => onChange(qId, e.target.value)}
      style={inputStyle(theme, !!error)}
    />
  )
}

export const NumberField: FC<FieldProps> = ({qId, question, value, error, onChange, theme}) => {
  const {config} = question
  return (
    <Box>
      <input
        type='number'
        value={value ?? ''}
        placeholder={config?.placeholder || ''}
        min={config?.min !== undefined && config.min !== '' ? config.min : undefined}
        max={config?.max !== undefined && config.max !== '' ? config.max : undefined}
        onChange={(e) => {
          const val = e.target.value
          if (val !== '' && config?.max !== undefined && config.max !== '') {
            if (Number(val) > Number(config.max)) {
              onChange(qId, config.max.toString())
              return
           }
         }
          onChange(qId, val)
       }}
        style={inputStyle(theme, !!error)}
      />
      {(config?.min !== undefined || config?.max !== undefined) && (
        <Box mt='4px'>
          <Text settings={{fontSize: '12px', color: theme.colors.gray}}>
            {config.min !== undefined && config.max !== undefined
              ? `Value between ${config.min} and ${config.max}`
              : config.min !== undefined
                ? `Minimum value: ${config.min}`
                : `Maximum value: ${config.max}`}
          </Text>
        </Box>
      )}
    </Box>
  )
}

export const ParagraphField: FC<FieldProps> = ({qId, question, value, error, onChange, theme}) => {
  const {config} = question
  return (
    <textarea
      value={(value as string) || ''}
      placeholder={config?.placeholder || ''}
      onChange={(e) => onChange(qId, e.target.value)}
      rows={3}
      style={{...inputStyle(theme, !!error), height: 'auto', minHeight: '100px', resize: 'vertical', padding: '12px 16px'}}
    />
  )
}
